import { supabaseClient } from '../net/supabase-client.js?v=20260801-token-hash-1';

async function call(name, args = {}) {
  const { data, error } = await supabaseClient.rpc(name, args);
  if (error) throw error;
  return data;
}

export const getMyClan = () => call('get_my_clan');
export const joinClanOnServer = (clanId, requestId = crypto.randomUUID()) => call('join_clan', {
  p_clan_id: String(clanId || ''),
  p_request_id: requestId,
});
export const skipClanRankOnServer = (targetRank, requestId = crypto.randomUUID()) => call('skip_clan_rank', {
  p_target_rank: Math.round(Number(targetRank)),
  p_request_id: requestId,
});
